<template>
  <section class="ma-4 ma-md-8">
    <t-page-title title="Eventos | Criar" />
    <v-row justify="center" align="center">
      <v-col>
        <form-event :event="event" @submit="submit" />
      </v-col>
    </v-row>
  </section>
</template>

<script lang="ts" setup>

import TPageTitle from '@/components/TPageTitle.vue'
import EventService from '@/services/EventService'
import { useLoader } from '@/stores/loader'
import Event from '@/types/Event'
import { Ref, ref } from 'vue'
import { useRouter } from 'vue-router'
import FormEvent from './form-event.vue'
import { ImageState } from './partials/form-event-images.vue'
import { useSnackBar } from '@/stores/snackbar'
import { SectorConfigState } from './partials/form-event-sectors.vue'

const router = useRouter()
const snackbar = useSnackBar()
const loader = useLoader()

const event: Ref<Event> = ref({
  title: '',
  subtitle: '',
  dates: {
    open: '',
    open_display: null,
    start: '',
    end: '',
    sales: {
      open: null,
      close: null,
    },
  },
  online_sales: false,
  max_online_tickets: 4,
  printing_required: false,
  document_required: false,
  name_required: false,
  show_on_homepage: true,
  show_on_whitelabel_page: true,
  description: '',
  insurance_policy: '',
  convenience_fee: 10,
  convenience_fee_mode: 'percentual',
})

async function submit(model: Event, images: ImageState[], sectorConfigs: SectorConfigState[]) {
  try {
    loader.increment()

    await new EventService().store(model, images.filter(image => image.dirty), sectorConfigs)

    snackbar.show('Evento criado com sucesso', 'success')
    loader.decrement()

    router.push({ name: 'list-events' })
  } catch {
    loader.decrement()
  }
}
</script>
